/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { Column } from '@g17eco/molecules/tracking-list';
import { ColumnCommonProps } from '@g17eco/types/survey-question-list';
import classNames from 'classnames';

export const ColumnStatus = (props: ColumnCommonProps & {
  value: number | string;
  icon: string;
  iconColor: string;
  textColor?: string;
}) => {
  const { handleGoToQuestion, icon, iconColor, textColor, value } = props;
  return (
    <Column className='codeCol pl-3 dont_translate' truncate onClick={handleGoToQuestion}>
      <div className='d-flex align-items-center gap-1'>
        <i className={classNames(`fal ${icon} text-lg`, iconColor)} />
        <span className={textColor ?? 'text-dark'}>{value}</span>
      </div>
    </Column>
  );
};
